<template>
  <div id="data-list-list-view">
    <add-new-data-sidebar
      :isSidebarActive="showAddSidebar"
      @closeSidebar="showAddSidebar = false"
      :form="sidebarForm"
      :title="sidebarTitle"
      :dados="sidebarData"
      @concluido="onCompleted"
    />

    <vs-table
      noDataText="Nenhuma Congênere Encontrada"
      ref="table"
      multiple
      v-model="selected"
      :max-items="itemsPerPage"
      :data="items"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
            >
              <span class="mr-2">Ações</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="deactivate"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Inativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="reactivate"
                v-if="$can($actionsDefault.Inativar, subjectPermission)"
              >
                <span>Reativar</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="print">
                <span>Imprimir</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                v-if="$can($actionsDefault.Exportar, subjectPermission)"
              >
                <span>
                  <downloadexcel
                    :data="selected"
                    :fields="columns"
                    name="congeneres.xls"
                    type="xls"
                    >Exportar</downloadexcel
                  >
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="openSidebar({})"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar novo Congênere</span
            >
          </div>
        </div>

        <div class="flex">
          <SelectPagination
            v-if="items.length > 0"
            :currentPage="currentPage"
            :itemsPerPage="itemsPerPage"
            :length="totalItems"
            @update="updateSelectPagination"
          />

          <vs-input
            class="searchable-input"
            icon="search"
            placeholder="Congênere ou Susep"
            v-model="searchQuery"
          />
        </div>
      </div>

      <template slot="thead">
        <vs-th>
          <div class="sortable-header" @click="handleSort('name')">
            Congênere
            <span v-if="sortKey !== 'name'" class="sort-icons-default">
              <feather-icon icon="ChevronUpIcon" svgClasses="h-3 w-3" />
              <feather-icon icon="ChevronDownIcon" svgClasses="h-3 w-3" />
            </span>
            <feather-icon
              v-else
              :icon="sortOrder === 'asc' ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              svgClasses="h-4 w-4 ml-1"
            />
          </div>
        </vs-th>
        <vs-th>
          <div class="sortable-header" @click="handleSort('susepCode')">
            Susep
            <span v-if="sortKey !== 'susepCode'" class="sort-icons-default">
              <feather-icon icon="ChevronUpIcon" svgClasses="h-3 w-3" />
              <feather-icon icon="ChevronDownIcon" svgClasses="h-3 w-3" />
            </span>
            <feather-icon
              v-else
              :icon="sortOrder === 'asc' ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              svgClasses="h-4 w-4 ml-1"
            />
          </div>
        </vs-th>
        <vs-th>
          <div class="sortable-header" @click="handleSort('status')">
            Status
            <span v-if="sortKey !== 'status'" class="sort-icons-default">
              <feather-icon icon="ChevronUpIcon" svgClasses="h-3 w-3" />
              <feather-icon icon="ChevronDownIcon" svgClasses="h-3 w-3" />
            </span>
            <feather-icon
              v-else
              :icon="sortOrder === 'asc' ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              svgClasses="h-4 w-4 ml-1"
            />
          </div>
        </vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.susepCode }}</p>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.deletedAt)"
                class="product-order-status"
                >{{ tr.deletedAt == null ? 'Ativo' : 'Inativo' }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <p class="product-price">
                <vs-button
                  radius
                  v-tooltip="'Detalhes'"
                  color="dark"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-search"
                  class="d-inline"
                  @click="openModal(tr.id)"
                ></vs-button>
                <vs-button
                  radius
                  v-tooltip="'Editar'"
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  class="d-inline"
                  @click="openSidebar(tr)"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                ></vs-button>
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div class="mt-6">
      <vs-pagination
        :total="Math.ceil(totalItems / itemsPerPage)"
        v-model="currentPage"
      ></vs-pagination>
    </div>

    <ModalInfo
      :modalSelecionado="selectedModal"
      :popupActive="popupActive"
      :title="`Dados do ${entity}`"
      @close="popupActive = false"
    ></ModalInfo>
  </div>
</template>

<script>
import functions from '@/utils/functions';
import SelectPagination from '@/utils/list/header/SelectPagination.vue';
import notify from '@/utils/notify';
import downloadexcel from 'vue-json-excel';
import ModalInfo from '../../components/ModalInfo';
import congenerApi from '../../services/congener.api.js';
import AddNewDataSidebar from './../Includes/SideBar';

export default {
  components: {
    AddNewDataSidebar,
    downloadexcel,
    ModalInfo,
    SelectPagination,
  },
  props: ['subjectPermission'],
  data() {
    return {
      idCompany: null,
      sidebarData: {},
      sidebarForm: 'Congener',
      entity: 'Congener',
      sidebarTitle: 'Adicionar Congener',
      popupActive: false,
      selectedModal: [],
      selected: [],
      items: [],
      columns: {
        Nome: 'name',
        'Código Susep': 'susepCode',
        Status: 'status',
      },
      currentPage: 1,
      itemsPerPage: 50,
      totalItems: 0,
      searchQuery: '',
      showAddSidebar: false,
      debounce: functions.debounce(this.fetchData, 1000),
      sortKey: '',
      sortOrder: 'asc',
    };
  },
  watch: {
    searchQuery: {
      immediate: true,
      handler: function () {
        this.resetCurrentPage();
        this.debounce();
      },
    },
    currentPage: {
      immediate: true,
      handler: function () {
        this.debounce();
      },
    },
    itemsPerPage: {
      immediate: true,
      handler: function () {
        this.currentPage = 1;
        this.fetchData();
      },
    },
  },
  methods: {
    handleSort(key) {
      if (this.sortKey === key) {
        if (this.sortOrder === 'asc') {
          this.sortOrder = 'desc';
        } else {
          this.sortKey = '';
          this.sortOrder = 'asc';
        }
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
      this.fetchData();
    },
    getSortKeyForBackend(key) {
      if (key === 'status') return 'deletedAt';
      return key;
    },
    print() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
    deactivate() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.id);
        });
        congenerApi
          .deactivateCongeners(ids)
          .then(() => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Registro inativado(s) com sucesso',
              color: 'success',
            });
            this.$vs.loading.close();
            this.fetchData();
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Selecione pelo menos um registro',
          color: 'danger',
        });
      }
    },
    reactivate() {
      if (this.selected.length > 0) {
        this.$vs.loading();
        var ids = [];
        this.selected.forEach((element) => {
          ids.push(element.id);
        });
        congenerApi
          .reactivateCongeners(ids)
          .then(() => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Registro reativado(s) com sucesso',
              color: 'success',
            });
            this.$vs.loading.close();
            this.fetchData();
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.$vs.loading.close();
          });
      } else {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Selecione pelo menos um registro',
          color: 'danger',
        });
      }
    },
    fetchData() {
      this.$vs.loading();
      this.selected = [];
      congenerApi
        .getCongenersFiltered({
          page: this.currentPage,
          items_per_page: this.itemsPerPage,
          search: this.searchQuery,
          sort_by: this.sortKey
            ? this.getSortKeyForBackend(this.sortKey)
            : undefined,
          sort_order: this.sortKey ? this.sortOrder : undefined,
        })
        .then((response) => {
          this.items = response.items;
          this.totalItems = response.total || 0;
          this.$vs.loading.close();
        })
        .catch((error) => {
          notify.notifyFail(this.$vs, error);
        });
    },
    openSidebar(data) {
      data.id == null
        ? (this.sidebarTitle = `Adicionar ${this.entity} `)
        : (this.sidebarTitle = `Editar dados do ${this.entity}`);
      this.sidebarData = data;
      this.showAddSidebar = true;
    },
    openModal(cod) {
      this.selectedModal = [];
      this.popupActive = true;
      var item = this.items.find((x) => x.id == cod);
      Object.keys(item).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        )
          this.selectedModal.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    onCompleted() {
      this.fetchData();
    },
    updateSelectPagination(value) {
      this.resetCurrentPage();
      this.itemsPerPage = value;
    },
    resetCurrentPage() {
      this.currentPage = 1;
    },
    getStatusColor(deletedAt) {
      if (deletedAt == null) return 'success';
      return 'danger';
    },
  },
  async mounted() {
    await this.fetchData();
  },
};
</script>

<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .sortable-header {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
  }

  .sort-icons-default {
    display: flex;
    flex-direction: column;
    margin-left: 4px;
    opacity: 0.5;

    .feather-icon {
      line-height: 0;
    }
  }

  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
